import React from 'react'
import { SecretFormProps } from './SecretForm.types'
import { useSecretFormProps } from './SecretForm.hooks'
import { Form, Formik } from 'formik'
import Button from '@/components/ui/Buttons/Button'
import { getSlug } from '@/utils/slug'
import CopyAdornment from '@/components/ui/CopyAdornment'
import { SecretValueInput } from '@/features/secrets'
import FormikInput from '@/components/formik/FormikInput'
import { LoadingButton } from '@/components/ui/Buttons/LoadingButton'

export const SecretForm = (props: SecretFormProps) => {
  const { projectId } = props
  const formikProps = useSecretFormProps(props)

  return (
    <Formik {...formikProps}>
      {({ values, isSubmitting }) => (
        <Form className={'d-grid gap-2'}>
          <div className={'d-flex gap-2'}>
            <FormikInput name={'name'} label={'Name'} className={'flex-grow-1'} />
            <FormikInput
              name={'slug'}
              label={'Slug'}
              value={getSlug(values.name)}
              disabled
              endAdornment={<CopyAdornment value={getSlug(values.name)} />}
            />
          </div>
          <SecretValueInput name={'value'} label={'Value'} projectId={projectId} />
          <LoadingButton isLoading={isSubmitting} type={'submit'} className={'mt-4'}>
            Create
          </LoadingButton>
        </Form>
      )}
    </Formik>
  )
}
